// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2Qnor","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3w8VY"};